'use client';
import React, { useEffect } from 'react';

import { adjustRouteSettings } from '1_components/RouteBasedSettings/RouteBasedSettings.utils';
import Preloader from '2_sections/Preloader/Preloader';

import useInitialSoundsPreload from 'hooks/useInitialSoundsPreload';
import { useRedirectWithAnimation } from 'hooks/useRedirectWithAnimation';

export interface InitialPreloadProps {}

const InitialPreload: React.FC<InitialPreloadProps> = () => {
  const router = useRedirectWithAnimation();
  const { progress: initialSoundsProgress } = useInitialSoundsPreload();

  useEffect(() => {
    adjustRouteSettings('');
  }, []);

  return (
    <Preloader
      progress={initialSoundsProgress}
      hideLoadingCircle
      hideHeading
      onAnimationComplete={() => {
        router.push('/landing');
      }}
      loadInterval={33}
      delay={300}
    />
  );
};

export default InitialPreload;
